import styled from "@emotion/styled"
import { FlexContainer } from "../../../../../styled/flexbox.styled"

export const InboxHeaderContainer = styled(FlexContainer)({
  width: "100%",
  paddingBottom: "10px",
})
